import React from 'react';
import './Navigation.css';

export default class Navigation extends React.Component {
	render() {
    const params = (new URL(document.location)).searchParams;
    const queryStringTheme = params.get('theme') || 'utherverse';

    const navigationItems = [
      { title: 'current', icon: 'fa-calendar-day'},
      { title: 'week', icon: 'fa-calendar-week' },
      { title: 'month', icon: 'fa-calendar-alt' }];

    if (this.props.mode !== '1') {
      navigationItems.push({
        title: 'create', icon: 'fa-calendar-plus', href: 'https://www.utherverse.com/events//Edit/index.html#?typeId=1x'
      },
      {
        title: 'manage', icon: 'fa-cog', href: 'https://www.utherverse.com/Events/Manager/'
      },
      {
        title: 'events team', icon: 'fa-users', href: 'https://mediarlcuv.wixsite.com/ambassadors/uv-home'
      }
      );
    }

		return(
			<nav className="left">
				<a href="#current" className="logo" onClick={() => this.props.handleNavigation('current')}>
          <img src={`${process.env.PUBLIC_URL}/logos/${queryStringTheme}.png`} alt="Logo" />
				</a>
        <ul className="navigation no-scrollbars">
          {navigationItems.map(({ title, icon, href }) => {
            return(
              <li
                key={title} 
                className={this.props.active === title ? 'active' : ''}
                onClick={() => !href && this.props.handleNavigation(title)}
              >
                <a href={href || `#${title}/`} target={href ? '_blank' : '_self'} rel="noreferrer">
                  <span className={`fas ${icon}`}></span>
                  <p>{title}</p>
                </a>
              </li>
            );
          })}
        </ul>
			</nav>
		);
	}
}